import { Navigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import LoginForm from "../../auth/LoginForm";

export default function StudentLogin() {
  const { isLoggedIn, role } = useAuth()
  if(role!=='student') localStorage.clear();
  
  if (isLoggedIn && role == 'student') return <Navigate to={'/course'} replace={true} />

  return (
    <>
      <div>
        <img className="h-12 mx-auto" src="../assets/image/learningportal.svg" />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
          Sign in to Student Account
        </h2>
      </div>
     
      <LoginForm roleType="student"/>
    </>
  )
}